@if (config.isGroup) {
  @if (config.hasVisibleParameters) {
    <div class="configuration group">
      <span class="configuration__title" [ngClass]="{'top': config.hasVisibleParameters}">{{ config.description }}</span>
      @for (member of config.members; track member) {
        <app-configuration
          [config]="member"
          [disableInput]="disableInput"
          (changed)="changed.emit($event)">
        </app-configuration>
      }
    </div>
  }
} @else {
  @if (config.properties.hidden === 'no') {
    <div class="configuration no-group">
      <span class="configuration__title">
        {{ config.description }}
        <app-tooltip
          class="accordion__category-details__info-icon"
          link="icon"
          text="{{ ('config-tooltip.' + config.name | translate) !== 'config-tooltip.' + config.name ? ('config-tooltip.' + config.name | translate) : '' }}">
        </app-tooltip>
      </span>
      @if (['dropdown', 'radio'].includes(config.properties.guitype)) {
        <app-select-box
          class="configuration__option"
          [attr.data-test]="'dropdown-' + config.name"
          [options]="config.domain.elements"
          [inputName]="config.name"
          [isSelectedFromOptions]="true"
          [optionLabelKey]="'description'"
          [inputDescription]="config.description"
          [disabled]="disableInput"
          (selected)="changed.emit($event)">
        </app-select-box>
      }
      @if (config.properties.guitype === 'text') {
        <app-textfield
          class="configuration__option" [attr.data-test]="'text-' + config.description"
          [domain]="config.domain"
          [inputName]="config.name"
          [modelValue]="config.value"
          [inputDescription]="config.description"
          [readOnly]="disableInput"
          [onKeyTimeout]="1000"
          (fieldFilled)="changed.emit($event)">
        </app-textfield>
      }
    </div>
  }
}
